import type { AssetTypeDeleteButtonProps } from "./asset-type-delete-button.type";

import ModelDeleteButton from "@/modules/model-delete-button";

import { useAssetTypeDeleteButton } from "./asset-type-delete-button.hook";

const AssetTypeDeleteButton = ({
  assetType,
  ...buttonProps
}: AssetTypeDeleteButtonProps) => {
  const { isDeletable, tooltip } = useAssetTypeDeleteButton({
    assetType,
  });

  return (
    <ModelDeleteButton
      modelKey="assettype"
      item={assetType}
      tooltip={tooltip}
      tooltipPlacement="bottomRight"
      disabled={!isDeletable}
      authorizeRender={!isDeletable ? "disabled" : "hidden"}
      {...buttonProps}
    />
  );
};

export default AssetTypeDeleteButton;
